import script from "./Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=7e7706d6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7706d6"]])

export default __exports__